import React from 'react';
import { WrapperFlex, Button } from '@unimed-fesp/components';

import { ContentText } from './styles';

const BodyRemoveAllParametrizacao = () => {
  return (
    <ContentText>
      Ao remover o perfil, também será removida a parametrização atual.
      <br />
      Deseja realmente remover?
    </ContentText>
  );
};

const FooterRemoveAllParametrizacao = ({ closeModal, onClickOk }) => {
  return (
    <WrapperFlex justifySpaceAround minWidth={250}>
      <Button tipo="secondary" onClick={closeModal} width={100} justifyCenter>
        não
      </Button>
      <Button onClick={onClickOk} width={100} justifyCenter>
        sim
      </Button>
    </WrapperFlex>
  );
};

export default { BodyRemoveAllParametrizacao, FooterRemoveAllParametrizacao };
